import { createNoopInjectionToken } from 'ngxtension/create-injection-token';

export const [injectGoogleClientId, provideGoogleClientId] =
  createNoopInjectionToken<string>('Google Client Id');
